import {
  IconButton,
  InputAdornment,
  SxProps,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useFormContext, UseFormRegister } from "react-hook-form";
import { motion } from "motion/react";

export interface InputProps {
  label: string;
  name: string;
  field: any;
  sx?: SxProps;
  required?: boolean;
  error?: string;
  icon?: React.ReactNode;
  type?: string;
  onClickIcon?: () => void;
  disabled?: boolean;
  multiline?: boolean;
  rows?: number;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
}

const Input = ({
  label,
  name,
  field,
  sx,
  required,
  error,
  icon,
  type,
  onClickIcon,
  disabled,
  multiline,
  rows,
  inputProps,
}: InputProps) => {
  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          {label}
        </Typography>
        <motion.div
          animate={{
            scale: error ? [1, 1.02, 1] : 1,
          }}
          transition={{
            duration: 0.2,
            times: [0, 0.5, 1],
          }}
        >
          <TextField
            // label={label}
            {...field}
            disabled={disabled}
            type={type}
            error={!!error}
            multiline={multiline}
            rows={rows}
            inputProps={inputProps}
            sx={{
              ...sx,
              width: "100%",
              transition: "border-color 0.3s ease-in-out",
            }}
            InputProps={{
              startAdornment: icon && (
                <InputAdornment position="start">
                  {onClickIcon ? (
                    <IconButton onClick={onClickIcon}>{icon}</IconButton>
                  ) : (
                    icon
                  )}
                </InputAdornment>
              ),
            }}
          />
        </motion.div>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{
          opacity: error ? 1 : 0,
          height: error ? "auto" : 0,
        }}
        transition={{
          duration: 0.3,
          ease: "easeInOut",
        }}
        style={{ overflow: "hidden" }}
      >
        {error && (
          <Typography
            variant="caption"
            color="error"
            sx={{
              color: "red",
              display: "block",
              mt: 0.5,
            }}
          >
            {error}
          </Typography>
        )}
      </motion.div>
    </>
  );
};

export default Input;
